import { render, staticRenderFns } from "./commodity-order.vue?vue&type=template&id=74c029b9&scoped=true&"
import script from "./commodity-order.vue?vue&type=script&lang=js&"
export * from "./commodity-order.vue?vue&type=script&lang=js&"
import style0 from "./commodity-order.vue?vue&type=style&index=0&id=74c029b9&scoped=true&lang=scss&"
import style1 from "./commodity-order.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c029b9",
  null
  
)

export default component.exports